import { Link } from 'react-router-dom';
import { Eye, ArrowRight } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const IdeaCard = ({ idea }) => {
  const statusColors = {
    available: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    in_development: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    sold: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
  };

  const statusLabels = {
    available: 'Available',
    in_development: 'In Development',
    sold: 'Sold',
  };

  return (
    <Link to={`/ideas/${idea.id}`} data-testid={`idea-card-${idea.id}`}>
      <div className="idea-card group relative overflow-hidden rounded-xl bg-slate-900/50 border border-white/10 hover:border-cyan-500/50 p-6 h-full">
        {/* Featured badge */}
        {idea.featured && (
          <div className="absolute top-4 right-4">
            <Badge className="bg-violet-500/20 text-violet-400 border-violet-500/30">
              Featured
            </Badge>
          </div>
        )}

        {/* Category */}
        <span className="text-xs font-mono uppercase tracking-wider text-cyan-400 mb-3 block">
          {idea.category}
        </span>

        {/* Title */}
        <h3 className="font-heading font-semibold text-xl text-white mb-2 group-hover:text-cyan-400 transition-colors line-clamp-2">
          {idea.title}
        </h3>

        {/* Tagline */}
        <p className="text-slate-400 text-sm mb-4 line-clamp-2">
          {idea.tagline}
        </p>

        {/* Tech stack */}
        <div className="flex flex-wrap gap-2 mb-4">
          {idea.tech_stack?.slice(0, 3).map((tech, idx) => (
            <span
              key={idx}
              className="text-xs px-2 py-1 rounded bg-slate-800 text-slate-300 border border-white/5"
            >
              {tech}
            </span>
          ))}
          {idea.tech_stack?.length > 3 && (
            <span className="text-xs px-2 py-1 rounded bg-slate-800 text-slate-400">
              +{idea.tech_stack.length - 3}
            </span>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between mt-auto pt-4 border-t border-white/5">
          <Badge className={statusColors[idea.status] || statusColors.available}>
            {statusLabels[idea.status] || 'Available'}
          </Badge>

          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1 text-slate-500 text-sm">
              <Eye className="h-4 w-4" />
              {idea.views || 0}
            </span>
            <ArrowRight className="h-4 w-4 text-slate-500 group-hover:text-cyan-400 group-hover:translate-x-1 transition-all" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default IdeaCard;
